import axios from 'axios';
import type { HttpError } from '@refinedev/core';
import Cookies from 'js-cookie';
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': import.meta.env.VITE_API_KEY,
  },
});
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const customError: HttpError = {
      ...error,
      message: error.response?.data?.message,
      statusCode: error.response?.status,
    };

    return Promise.reject(customError);
  }
);
axiosInstance.interceptors.request.use((config) => {
  const token = Cookies.get('accessToken');
  let locale = Cookies.get('locale');

  // Remove any quotes (single or double) from the locale string
  if (locale) {
    locale = locale.replace(/['"]+/g, ''); // This removes both single and double quotes
    config.headers['Accept-Language'] = locale;
  } else {
    config.headers['Accept-Language'] = 'ar'; // Default to 'ar' if no locale is set
  }
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
});
// response interceptor to update the token
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.headers && response.headers['x-extended-access-token']) {
      const newToken = response.headers['x-extended-access-token'];
      if (newToken) {
        Cookies.set('accessToken', newToken);
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      (error.response && error.response.status === 403) ||
      error.response.status === 401
    ) {
      localStorage.removeItem('refine-auth');
      window.location.href = '/login';
      Cookies.remove('accessToken');
    }

    return Promise.reject(error);
  }
);
export const setAuthToken = (token: string | null) => {
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    Cookies.set('accessToken', token);
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
    Cookies.remove('accessToken');
  }
};
export { axiosInstance };
